import { fromJS } from 'immutable';
import { GET_LOG, GET_REPLAY, SET_LOG, SET_REPLAY } from './constants';

export const getLog = (gameId) => ({
  type: GET_LOG,
  payload: fromJS({ gameId }),
});

export const getReplay = (gameId) => ({
  type: GET_REPLAY,
  payload: fromJS({ gameId }),
});

/** The log with each move's board (`board`), as the server sent it. */
export const setReplay = (gameId, entries) => ({
  type: SET_REPLAY,
  payload: { gameId, entries },
});

/** The log as the server sent it: plain entries, which describeEntry reads as they are. */
export const setLog = (gameId, entries) => ({
  type: SET_LOG,
  payload: { gameId, entries },
});
